import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';

const borrowerSellerPurposes = {
  [ePartyPurpose.borrower]: true,
  [ePartyPurpose.buyer]: true,
  [ePartyPurpose.seller]: true,
};

// Returns a subset of parties.
// The elements of the subset must be Persons and Buyers, Borrowers, or Sellers.
export const determineBorrowersSellers = (parties: IParty[]): IParty[] =>
  parties.filter(({ type, purpose }: IParty) => type === ePartyType.person && borrowerSellerPurposes[purpose]);
